var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.658,
    height: 44.877,
    viewBox: "0 0 33.658 44.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.658,
    height: 44.877,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.01,11.611H12.389A4.718,4.718,0,0,1,7.675,6.9V4.714A4.718,4.718,0,0,1,12.389,0H17.01a4.719,4.719,0,0,1,4.714,4.714V6.9a4.719,4.719,0,0,1-4.714,4.714M12.389,1.277A3.441,3.441,0,0,0,8.952,4.714V6.9a3.44,3.44,0,0,0,3.436,3.436H17.01A3.44,3.44,0,0,0,20.447,6.9V4.714A3.441,3.441,0,0,0,17.01,1.277Z",
    transform: "translate(2.129 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M21.481,19.376H9.134a3.655,3.655,0,0,1-3.651-3.651V11.74A3.655,3.655,0,0,1,9.134,8.089H21.481a3.655,3.655,0,0,1,3.65,3.651v3.986a3.655,3.655,0,0,1-3.65,3.651M9.134,9.366A2.377,2.377,0,0,0,6.76,11.74v3.986A2.377,2.377,0,0,0,9.134,18.1H21.481a2.376,2.376,0,0,0,2.372-2.373V11.74a2.376,2.376,0,0,0-2.372-2.373Z",
    transform: "translate(1.521 2.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M20.64,33.58H9.974a4.5,4.5,0,0,1-4.491-4.491V20.418a4.5,4.5,0,0,1,4.491-4.493H20.64a4.5,4.5,0,0,1,4.491,4.493v8.671A4.5,4.5,0,0,1,20.64,33.58M9.974,17.2A3.218,3.218,0,0,0,6.76,20.418v8.671A3.218,3.218,0,0,0,9.974,32.3H20.64a3.218,3.218,0,0,0,3.214-3.214V20.418A3.218,3.218,0,0,0,20.64,17.2Z",
    transform: "translate(1.521 4.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M5.987,37.536a3.339,3.339,0,0,1-2.368-.98L.98,33.917a3.355,3.355,0,0,1,0-4.738l1.744-1.744a3.355,3.355,0,0,1,4.738,0L10.1,30.075a3.355,3.355,0,0,1,0,4.738L8.357,36.556a3.344,3.344,0,0,1-2.37.98m-2.361-9.2L1.883,30.082a2.075,2.075,0,0,0,0,2.932l2.639,2.639a2.077,2.077,0,0,0,2.932,0L9.2,33.91a2.077,2.077,0,0,0,0-2.932L6.558,28.339a2.077,2.077,0,0,0-2.932,0",
    transform: "translate(0 7.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M22.767,37.536a3.342,3.342,0,0,1-2.37-.979l-1.744-1.745a3.355,3.355,0,0,1,0-4.738l2.639-2.638a3.354,3.354,0,0,1,4.738,0l1.744,1.744a3.351,3.351,0,0,1,0,4.738l-2.639,2.639a3.339,3.339,0,0,1-2.368.979m.894-9.8a2.063,2.063,0,0,0-1.465.607l-2.639,2.638a2.074,2.074,0,0,0,0,2.932L21.3,35.654a2.079,2.079,0,0,0,2.932,0l2.639-2.639a2.074,2.074,0,0,0,0-2.932L25.128,28.34a2.066,2.066,0,0,0-1.466-.607",
    transform: "translate(4.903 7.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M26.508,35.408H4.825a.639.639,0,1,1,0-1.277H26.508a.639.639,0,1,1,0,1.277",
    transform: "translate(1.161 9.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M5.828,33.194A.644.644,0,0,1,5.6,33.15,6.886,6.886,0,0,1,.988,25.566a7.279,7.279,0,0,1,1.461-3.149,3.911,3.911,0,0,0,.984-2.284,4.759,4.759,0,0,0-.7-2.8,5.128,5.128,0,0,1-.752-2.257A5.285,5.285,0,0,1,3.342,11.29c1.652-1.9,4.493-2.98,8.443-3.2a.638.638,0,1,1,.072,1.275C7.381,9.614,5.281,11,4.306,12.127a3.926,3.926,0,0,0-1.055,2.84,3.9,3.9,0,0,0,.6,1.748,5.957,5.957,0,0,1,.862,3.432,5.079,5.079,0,0,1-1.217,3.007A6.137,6.137,0,0,0,2.248,25.78a5.627,5.627,0,0,0,3.811,6.18.639.639,0,0,1-.231,1.234",
    transform: "translate(0.251 2.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M23.029,33.194A.639.639,0,0,1,22.8,31.96a5.628,5.628,0,0,0,3.811-6.18,6.149,6.149,0,0,0-1.244-2.628,5.081,5.081,0,0,1-1.219-3.006,5.967,5.967,0,0,1,.862-3.432,3.882,3.882,0,0,0,.6-1.748,3.927,3.927,0,0,0-1.055-2.84c-.975-1.122-3.075-2.513-7.55-2.761a.639.639,0,0,1-.6-.673.629.629,0,0,1,.673-.6c3.951.218,6.792,1.3,8.444,3.2a5.285,5.285,0,0,1,1.363,3.786,5.128,5.128,0,0,1-.752,2.257,4.758,4.758,0,0,0-.7,2.8,3.915,3.915,0,0,0,.985,2.283,7.284,7.284,0,0,1,1.46,3.15,6.884,6.884,0,0,1-4.608,7.584.644.644,0,0,1-.231.043",
    transform: "translate(4.549 2.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M19.867,20.977H9.1a.639.639,0,0,1,0-1.277H19.867a.639.639,0,1,1,0,1.277",
    transform: "translate(2.346 5.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M19.867,23.613H9.1a.639.639,0,1,1,0-1.277H19.867a.639.639,0,1,1,0,1.277",
    transform: "translate(2.346 6.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M19.867,26.249H9.1a.639.639,0,1,1,0-1.277H19.867a.639.639,0,1,1,0,1.277",
    transform: "translate(2.346 6.927)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M19.867,13.284H9.1a.639.639,0,0,1,0-1.277H19.867a.639.639,0,1,1,0,1.277",
    transform: "translate(2.346 3.331)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.8faab605067874ab27d84626c9bbf524.svg";
export { ForwardRef as ReactComponent };